export default __webpack_public_path__ + "static/media/Richard.fd96dd93.png";